import React from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const Layout = ({ children }) =>  {
  return (
    <div style={{ display: 'flex' }}>
        <Sidebar />
        <div style={{ display: 'block', width: '100%' }}>
            <Navbar />
            <div style={{ padding: '20px',width:'86%', marginLeft:'225px'}}>
              <div  className="row">
                  <div style={{marginTop:'80px'}} className="col-md-12">
                  <main className='main_section' style={{fontSize:'15px', fontWeight:'400', background:'white',boxShadow:'rgba(100, 100, 111, 0.2) 0px 7px 29px'}}>{children}</main>
                  </div>
              </div>
              
            </div>
        </div>
    </div>
  )
}
export default Layout;
